import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ReportState } from './report.reducers';

export const selectReportState = createFeatureSelector<ReportState>('report');

export const selectReportList = createSelector(selectReportState, (state) => state.reportList);

export const selectReportListFilter = createSelector(selectReportList, (state) => state.filter);
export const selectReportListShowing = createSelector(selectReportList, (state) => state.showing);
export const selectReportListEngineVersion = createSelector(selectReportList, (state) => state.engineVersion);
export const selectReportListSelectedRow = createSelector(selectReportList, (state) => state.reportListSelectedRow);

export const selectGenerate = createSelector(selectReportState, (state) => state.generate);
export const selectGenerateRequestId = createSelector(selectGenerate, (state) => state.requestId);
export const selectGenerateReportName = createSelector(selectGenerate, (state) => state.reportName);
export const selectGenerateMessage = createSelector(selectGenerate, (state) => state.message);
export const selectGenerateParams = createSelector(selectGenerate, (state) => state.params);
